module.exports = __webpack_public_path__ + "static/media/use-heart.cf144928.svg";